import { render, staticRenderFns } from "./OverlayTutoList.vue?vue&type=template&id=5a368519&scoped=true&"
import script from "./OverlayTutoList.vue?vue&type=script&lang=js&"
export * from "./OverlayTutoList.vue?vue&type=script&lang=js&"
import style0 from "./OverlayTutoList.vue?vue&type=style&index=0&id=5a368519&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a368519",
  null
  
)

component.options.__file = "OverlayTutoList.vue"
export default component.exports